import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { bumpBulkSelectionForwardNavEpoch, canonicalPathForBulkSelectionNav } from '@/lib/bulkSelectionForwardNavEpoch';

/**
 * Bumps bulk-selection navigation epoch only for forward transitions (PUSH/REPLACE).
 * POP (back) does not bump — list → detail → back still consumes only one "forward" step of budget.
 */
export function BulkSelectionForwardNavigationListener() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const prevCanonicalRef = useRef<string | null>(null);

  useEffect(() => {
    const key = canonicalPathForBulkSelectionNav(location);

    if (prevCanonicalRef.current === null) {
      prevCanonicalRef.current = key;
      return;
    }

    if (navigationType === 'POP') {
      prevCanonicalRef.current = key;
      return;
    }

    if (key !== prevCanonicalRef.current) {
      bumpBulkSelectionForwardNavEpoch();
    }
    prevCanonicalRef.current = key;
  }, [location, navigationType]);

  return null;
}
